module.exports = __webpack_public_path__ + "img/EconomyTechBackgroundC03_ua.e0721330.webp";